/* eslint-disable react/forbid-prop-types */
import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';
import { ActivityContext, IActivityContext } from '@bingads-webui-react/instrumentation-context';

export const withActivityContext = <P extends object>(WrappedComponent: React.ComponentType<P & { activity: IActivityContext }>): React.ComponentType<P> => {
  const HoC: React.FC<P> = (props: P) => (
    <ActivityContext.Consumer>
      {(context) => (
        <WrappedComponent
          {...props}
          activity={context}
        />
      )}
    </ActivityContext.Consumer>
  );

  HoC.displayName = `withActivityContext(${getDisplayName(WrappedComponent)})`;

  return hoistNonReactStatics(HoC, WrappedComponent) as React.ComponentType<P>;
};
